import { IAgentFlags } from "store/entities/agents";

export enum SettingsSection {
  EmailAddresses = "email-addresses",
  CannedResponses = "canned-responses",
  Tags = "tags",
  CustomFields = "custom-fields",
  Notifications = "notifications",
  MyViews = "my-views",
  EmailTemplates = "email-templates",
  Integrations = "integrations",
  AutomatedWorkflows = "workflows",
  ContactForms = "contact-forms",
  Spam = "spam",
  API = "api",
  OpenWidget = "open-widget",
  LiveChat = "live-chat",
}

export const SETTINGS_SECTION_KEYS = {
  [SettingsSection.EmailAddresses]: "emailAddressesSectionVisitedDate",
  [SettingsSection.CannedResponses]: "cannedResponsesSectionVisitedDate",
  [SettingsSection.Tags]: "tagsSectionVisitedDate",
  [SettingsSection.CustomFields]: "customFieldsSectionVisitedDate",
  [SettingsSection.Notifications]: "notificationsSectionVisitedDate",
  [SettingsSection.EmailTemplates]: "emailTemplatesSectionVisitedDate",
  [SettingsSection.MyViews]: "myViewsSectionVisitedDate",
  [SettingsSection.Integrations]: "integrationsSectionVisitedDate",
  [SettingsSection.AutomatedWorkflows]: "automatedWorkflowsSectionVisitedDate",
  [SettingsSection.ContactForms]: "contactFormsSectionVisitedDate",
  [SettingsSection.Spam]: "spamSectionVisitedDate",
  [SettingsSection.API]: "apiSectionVisitedDate",
  [SettingsSection.OpenWidget]: "openWidgetSectionVisitedDate",
  [SettingsSection.LiveChat]: "liveChatSectionVisitedDate",
} satisfies Record<SettingsSection, keyof IAgentFlags>;

export const SETTINGS_NEW_FEATURE_CAMPAIGNS: { [key in SettingsSection]?: [string, string, string][] } = {
  [SettingsSection.ContactForms]: [["2021-09-27T14:00:00.000Z", "2021-10-18T02:00:00.000Z", "CONTACT_FORMS_FROM_API"]],
  [SettingsSection.CustomFields]: [["2022-11-03T09:31:01.578Z", "2022-11-24T09:31:01.578Z", ""]],
  [SettingsSection.EmailTemplates]: [["2023-09-06T01:09:54.819Z", "2023-09-22T23:59:59.578Z", ""]],
  [SettingsSection.Integrations]: [["2022-12-20T08:30:05.658Z", "2023-02-28T23:59:59.578Z", ""]],
  [SettingsSection.OpenWidget]: [["2023-11-08T00:00:00.000Z", "2023-11-22T23:59:59.999Z", ""]],
  [SettingsSection.CannedResponses]: [["2023-11-06T11:22:34.390Z", "2023-11-20T08:43:10.987Z", ""]],
};
